import { CertificateTypeFilterEnum } from '@/shared/types/graphql/globals.v5';

import type { TFilterDiplomasCollaboratorOption } from './type';

export const DIPLOMA_FILTER = {
  ALL: 0,
  CERTIFICATIONS: 1,
  CONSTANCIES: 2,
} as const;

export const DIPLOMA_FILTER_COLLABORATOR: Record<
  string,
  TFilterDiplomasCollaboratorOption
> = {
  ALL: 'ALL',
  CERTIFICATIONS_COURSE: CertificateTypeFilterEnum.CERTIFICATE_TYPE_COURSE,
  CERTIFICATIONS_TRACKS: CertificateTypeFilterEnum.CERTIFICATE_TYPE_TRACK,
  PARTICIPANTS_CERTIFICATIONS:
    CertificateTypeFilterEnum.CERTIFICATE_TYPE_PARTICIPATION_CERTIFICATE,
} as const;
